import { render, staticRenderFns } from "./TabContentLayout.vue?vue&type=template&id=65f5dbea&"
import script from "./TabContentLayout.vue?vue&type=script&lang=js&"
export * from "./TabContentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports